export const apiUrls = {
    plant: 'api/plant',
    generic: 'api/generic',
    emergencyPlan: 'api/emergencyPlan',
}